module.exports = __webpack_public_path__ + "static/media/Logos.aa8cef3f.png";